// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Outlet } from 'react-router-dom'
import { Leaf } from 'lucide-react'
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-sand flex flex-col">
      {/* Header */}
      <header className="flex justify-center pt-8 pb-4 px-6">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-moss shadow-soft">
            <Leaf className="h-4.5 w-4.5 text-white" />
          </div>
          <span className="text-lg font-semibold text-ink tracking-tight">WilsApp</span>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-start justify-center px-4 pt-4 pb-12">
        <div className="w-full max-w-auth animate-fade-in">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>

      {/* Footer privacy note */}
      <footer className="pb-8 px-6 text-center">
        <p className="text-xs text-ink-4 max-w-xs mx-auto leading-relaxed">
          Geen opslag van documenten of wachtwoorden.
          Uw gegevens blijven op uw apparaat.
        </p>
      </footer>
    </div>
  )
}
